exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** Bootstrap navbar fix (https://git.io/fADqW) */\n.star[data-v-638b2a5c] {\n  fill: #d0d0d0;\n}\n.star--active[data-v-638b2a5c] {\n  fill: #af3338;\n}", ""]);

// exports
